import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import OnewayPickupPeriodicHikeDayDrawer from "components/drawer/OnewayPeriodicHikeDayDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import dayjs from "dayjs";

const OnewayPickupPeriodicHikeDayTable = ({
    OnewayPickupBasicRate,
    perpage,
    currentPage,
    hideDelete,
    hideEdit,
}) => {
    const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
    const onewaypickupdata = OnewayPickupBasicRate;
    return (
        <>
            <DeleteModal id={serviceId} title={title} />

            <MainDrawer>
                <OnewayPickupPeriodicHikeDayDrawer id={serviceId} />
            </MainDrawer>

            <TableBody>
                {onewaypickupdata?.slice(0, perpage || 10).map((data, index) => (
                    <React.Fragment key={data.id}>
                        {(data.vehicle_type_id || []).map((vehicleId, vehicleIndex) => (
                            <TableRow key={`${data.id}-${vehicleId}`}>

                                {vehicleIndex === 0 && (
                                    <>
                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-xs text-center"
                                        >
                                            {((currentPage || 1) - 1) * (perpage || 10) + index + 1}
                                        </TableCell>

                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-xs text-center"
                                        >
                                            {data.from_city_name?.join(", ") || "-"}
                                        </TableCell>

                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-xs text-center"
                                        >
                                            {data.to_city_name?.join(", ") || "-"}
                                        </TableCell>

                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-xs text-center"
                                        >
                                            {dayjs(data.start_date).format("DD-MM-YYYY")}
                                        </TableCell>

                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-xs text-center"
                                        >
                                            {dayjs(data.end_date).format("DD-MM-YYYY")}
                                        </TableCell>
                                    </>
                                )}

                                {/* Vehicle name */}
                                <TableCell className="text-xs text-center">
                                    {data.vehicle_type_names?.[vehicleId] || "-"}
                                </TableCell>

                                {/* Hike */}
                                <TableCell className="text-center text-xs px-4 py-3">
                                    {data?.hike?.[vehicleId] ? `${data.hike[vehicleId]}%` : "-"}
                                </TableCell>

                                {vehicleIndex === 0 && (
                                    <TableCell
                                        rowSpan={data.vehicle_type_id.length}
                                        className="text-center"
                                    >
                                        <EditDeleteButton
                                            title="Oneway Pickup"
                                            id={data.id}
                                            handleUpdate={handleUpdate}
                                            handleModalOpen={handleModalOpen}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </React.Fragment>
                ))}
            </TableBody>



        </>
    );
};

export default OnewayPickupPeriodicHikeDayTable;
